export { AddConsentDocument } from './lib/addConsent/addConsent.generated';

export type {
    AddConsentMutation,
    AddConsentMutationVariables
} from './lib/addConsent/addConsent.generated';

export { DeleteTrackedPropertyDocument } from './lib/deleteTrackedProperty/deleteTrackedProperty.generated';

export type {
    DeleteTrackedPropertyMutation,
    DeleteTrackedPropertyMutationVariables
} from './lib/deleteTrackedProperty/deleteTrackedProperty.generated';

export { DeleteTrackedPropertyPermissionsDocument } from './lib/deleteTrackedPropertyPermissions/deleteTrackedPropertyPermissions.generated';

export type {
    DeleteTrackedPropertyPermissionsMutation,
    DeleteTrackedPropertyPermissionsMutationVariables
} from './lib/deleteTrackedPropertyPermissions/deleteTrackedPropertyPermissions.generated';

export { SaveTrackedPropertyDocument } from './lib/savedTrackedProperty/savedTrackedProperty.generated';

export type {
    SaveTrackedPropertyMutation,
    SaveTrackedPropertyMutationVariables
} from './lib/savedTrackedProperty/savedTrackedProperty.generated';

export { UpdateUserProfileDocument } from './lib/updateUserProfile/updateUserProfile.generated';
export { initialUserProfileState } from './lib/updateUserProfile/initialUserProfileState';

export type {
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
} from './lib/updateUserProfile/updateUserProfile.generated';

export { FetchUserDocument } from './lib/user.generated';

export type {
    FetchUserQuery,
    FetchUserQueryVariables
} from './lib/user.generated';

export type { User } from './graphql.generated';
